import {makeReducer} from '../../redux-toolbelt';

import {setJustAddedDishToShoppingCart} from './justAddedDishToShoppingCartActions';

type JustAddedDishToShoppingCartState = boolean;

export default makeReducer<JustAddedDishToShoppingCartState, JustAddedDishToShoppingCartState>(setJustAddedDishToShoppingCart);
